// src/features/tidsregistering/services/unavailability.js
import { apiClient } from '../../../services/api/client';

const BASE = '/api/v1/tidsregistering/unavailability';

export const unavailabilityAPI = {
  getDepartmentUnavailability: (startDate, endDate) =>
    apiClient.get(`${BASE}/department`, { params: { start_date: startDate, end_date: endDate } }),

  checkStaffAvailability: (staffMemberId, startDate, endDate, startTime = null, endTime = null) =>
    apiClient.get(`${BASE}/staff/${staffMemberId}`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        ...(startTime && { start_time: startTime }),
        ...(endTime && { end_time: endTime }),
      },
    }),
};
